import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { getLanguageCode } from '../../utils/utils';

import DocumentsCarousel from './DocumentsCarousel';

import { getWebContainerQuery } from '@queries/editorial';

import * as styles from './styles.module.scss';

import 'swiper/scss';

const Stories = () => {
  const { t } = useTranslation();

  const { locale } = useParams();
  const { data: documents } = useQuery(getWebContainerQuery('PLAYMAKERS.STORIES', getLanguageCode(locale)));

  if (!documents?.length) return null;

  return (
    <div id='stories' className={styles.section}>
      <div
        className={styles.section__content}
        itemScope
        itemType='https://schema.org/ItemList https://schema.org/CreativeWork'
      >
        <h2 className={styles.title} itemProp='name'>
          {t('stories-title')}
        </h2>
        <h3 className={styles.subtitle}>{t('stories-subtitle')}</h3>
        <DocumentsCarousel documents={documents} containerName={null} />
      </div>
    </div>
  );
};

export default Stories;
